import { parallel, safe } from "../fx/mod.js";
export function createRun(scope) {
    function run(op) {
        if (Array.isArray(op)) {
            return scope.run(function* () {
                const group = yield* parallel(op);
                const result = yield* group;
                return result;
            });
        }
        return scope.run(() => safe(op));
    }
    return run;
}
//# sourceMappingURL=run.js.map